import { useQuery } from '@tanstack/react-query'
import { Text } from '@viapeople/components'
import { trpc } from '../../../utils/trpc'

interface EnabledOrganizationsCountCellProps {
	flagId: string
}

export const EnabledOrganizationsCountCell = ({ flagId }: EnabledOrganizationsCountCellProps) => {
	const { data: organizations = [], isLoading } = useQuery({
		...trpc.admin.featureFlagsManagementPage.getOrganizations.queryOptions({ flagId }),
		enabled: !!flagId,
	})

	if (isLoading) {
		return (
			<Text variant='xsmall' className='text-neutral-400'>
				-
			</Text>
		)
	}

	const enabledCount = organizations.filter((org) => org.enabled).length

	return (
		<Text variant='xsmall' className='text-neutral-600'>
			{enabledCount}
		</Text>
	)
}
